/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Style } from './style';
import { typesConfigs } from '../../../../../../constants/types';
import { getSourceName, useModule } from '../../../../../../helpers/user';
import { useSelector } from 'react-redux';

const Sider = ({
  activeSources = [],
  activeNode = null,
  t = (s) => s,
  supplyChainActors = [],
  informationSources = [],
  ownDataSources = [],
  projectData = {},
  type = 'default',
  close = () => { },
}) => {
  const { mod } = useModule();
  const { sources } = useSelector((state) => state.project);

  const activeNodeRendered = useMemo(() => {
    if (activeNode) {
      const config = typesConfigs.find((c) => c.type === activeNode.type);

      if (config) {
        return (
          <div className="active-node-container">
            <div className="close-header">
              <CloseOutlined onClick={close} />
            </div>
            <div className="header-second">
              <div className="main flex-c">
                <label>
                  {activeNode?.datastakeId}
                </label>
                <h1>{activeNode.label}</h1>
              </div>
            </div>
            <label className="sources-label">{t('Sources Reporting on this Subject')}</label>
            <div className="sources">
              {activeNode.sources.map((source, i) => {
                const supplyChainActor = supplyChainActors.find((s) => s.id === source);
                const infoSource = informationSources.find((s) => s.id === source);
                const ownSource = ownDataSources.find((s) => s.id === source);
                const participant = sources.find((p) => p.authorId === source);
                const _participant = participant ? { label: getSourceName(participant) || '' } : null;

                const s = supplyChainActor || infoSource || ownSource || _participant || { label: 'MyOwnCompany' };

                return (
                  <div className="source" key={`source-${source}-${i}`}>
                    <Link
                      to={`/app/${mod}/view/${activeNode.namespace}/${activeNode.datastakeId}?sourceId=${source}`}
                      target="_blank"
                    >
                      {s.label}
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        );
      }
    }
    return null;
  }, [activeNode, t, activeSources]);

  const render = () => {
    switch (type) {
      default:
        return (
          <Style className={!!activeNodeRendered && 'visible'}>
            <div className="section">
              <div className="body">
                {activeNodeRendered}
              </div>
            </div>
          </Style>
        );
    }
  };

  return render();
}

export default Sider;
